import useAuthStore from '@vue3/store/auth-store'
import useCommonStore from '@vue3/store/common-store.js'
import { shouldMakeSessionUpdateCall } from './common'
import { app } from '@vue3/configs'
import pinia from '@vue3/store/init'
import constants from '@vue3/constants'
const { EMAIL_VERIFICATION_DONE } = constants.companyRegistrationStatus

const registrationSteps = {
  REJECTED: 'dealerType',
  REGISTRATION_TYPE: 'dealerType',
  DEALER_DATA: 'dealerInfo',
  PIC_DATA: 'picInfo',
  SUPPORTING_DATA: 'supportDocs',
  CREDIT_LIMIT_DATA: 'termsOfPayment'
}


let authStore = null
const commonStore = useCommonStore(pinia)

const getAuthStore = () => {
  if (authStore == null) {
    authStore = useAuthStore(pinia)
  }
  return authStore
}

const routeTo = (data, next, meta, routeName, fromPath) => {
  const initialRoute = routeName
  if (!data.emailVerified) {
    routeName = app.routerName.verifyEmail
  } else if (data?.companyDetails?.companyRegistrationStatus === constants.companyRegistrationStatus.APPROVED) {
    if (meta.auth) {
      if (meta.notAllowedAfterRegistration) {
        routeName = app.routerName.homePage
      } else if (meta.checkAccessFromConfig) {
        const isUserHasAccess = validateRouteAccessBasedOnConfig(meta.configName)
        if (!isUserHasAccess) {
          routeName = app.routerName.homePage
        }
      } else {
        // does nothing - required
      }
    } else {
      routeName = app.routerName.homePage
    }
  } else if (data?.companyDetails?.companyRegistrationStatus === constants.companyRegistrationStatus.APPROVAL_PENDING) {
    commonStore.setAppLoader(false)
    routeName = app.routerName.login
  } else {
    const isEmailVarificationCompleted = data?.registrationStatus === EMAIL_VERIFICATION_DONE
    const hasNoCurrentCompanyInfo = !Object.keys(data?.companyDetails || {}).length
    const hasMappedTenants = data?.tenantDetailsDTOS?.length
    const isUserLoggedInButTenantNotSelected = isEmailVarificationCompleted && hasNoCurrentCompanyInfo && hasMappedTenants
    if (isUserLoggedInButTenantNotSelected) {
      commonStore.setAppLoader(false)
      routeName = app.routerName.login
    } else {
      const inProgressStep = data?.companyDetails?.registrationNextStep || data?.registrationNextStep
      if (!inProgressStep || !registrationSteps[inProgressStep]) {
        routeName = registrationSteps.REGISTRATION_TYPE
      } else {
        routeName = registrationSteps[inProgressStep]
      }
    }
  }
  if (initialRoute === routeName) {
    commonStore.setAppLoader(false)
    next()
    return
  }
  if (routeName === fromPath) {
    commonStore.setAppLoader(false)
  }
  commonStore.setAppLoader(false)
  next({ name: routeName })
}

const handleAuthenticatedRoute = (user, meta, next, nextPath, fromPath) => {
  if (meta.auth) {
    routeTo(user, next, meta, nextPath, fromPath)
  } else if (nextPath === app.routerName.verifyEmailWithId || nextPath === app.routerName.resetPassword) {
    commonStore.setAppLoader(false)
    next()
  } else {
    routeTo(user, next, meta, nextPath, fromPath)
  }
}

const handleNotAuthenticatedRoute = (meta, next) => {
  if (meta.auth) {
    next({ name: app.routerName.landingPage })
  } else {
    commonStore.setAppLoader(false)
    next()
  }
}

export function userCheck (next, nextPath, fromPath, meta) {
  const authStore = getAuthStore()
  const isUserFetchFinished = authStore.isUserFetchFinished
  if (nextPath === app.routerName.termsAndCondition) {
    commonStore.setAppLoader(false)
    next()
    return
  }
  if (!isUserFetchFinished) {
    setTimeout(() => {
      userCheck(next, nextPath, fromPath, meta)
    }, 400)
    return
  }
  if (authStore.isLoggedIn) {
    invokeSessionUpdatePerDayOnce()
    handleAuthenticatedRoute(authStore.userDetails, meta, next, nextPath, fromPath)
  } else {
    handleNotAuthenticatedRoute(meta, next)
  }
}

export function setAuthError (errorCode) {
  commonStore.setErrorCode(errorCode)
}

const validateRouteAccessBasedOnConfig = (configName) => {
  const authStore = getAuthStore()
  const isAppConfigFetched = authStore.isAppConfigFetched
  if (isAppConfigFetched) {
    const configValue = authStore.appConfigs?.[configName]
    const whitelistedUsers = authStore.appConfigs?.whitelistedUsers || []
    const isFeatureEnabled = configValue?.isEnabled
    if (!isFeatureEnabled) { return false }
    const isOnlyForWhitelistedUsers = configValue?.isOnlyForWhitelistedUsers
    if (!isOnlyForWhitelistedUsers) { return true }
    return whitelistedUsers.includes(authStore.userDetails.email)
  } else {
    // const query = {
    //   id: 'applereseller.ui.config',
    //   requestId: 'apple-reseller-ui',
    //   clientId: 'apple-reseller-ui',
    //   storeId: '10001',
    //   channelId: commonStore.getIsMobile ? 'mobile' : 'web'
    // }
    // authStore.getAppConfiguration({
    //   query,
    //   success: () => validateRouteAccessBasedOnConfig(configName)
    // })
    validateRouteAccessBasedOnConfig(configName)
  }
}

const invokeSessionUpdatePerDayOnce = () => {
  if (shouldMakeSessionUpdateCall()) {
    const authStore = getAuthStore()
    authStore.updateSession()
  }
}

export const checkLoginStatusAndInvokeSessionUpdate = () => {
  const authStore = getAuthStore()
  if (authStore.isLoggedIn) {
    invokeSessionUpdatePerDayOnce()
  }
}
